/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import {
  Form,
  InputGroup,
  Table,
  Modal,
  Button,
  Dropdown,
} from "react-bootstrap";

import React, { useEffect, Fragment, useRef } from "react";
import ReactPaginate from "react-paginate";
import { useTranslate } from "../hooks/LanguageProvider";
import { Link, useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { Bounce, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExcelJS from "exceljs";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import "../App.css";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface DeletedUser {
  id_user: number;
  name: string;
}

interface User {
  id_user: number;
  id_role: number;
  nom_user: string;
  prenom_user: string;
  username_user: string;
  email_user: string;
  phone_user: string;
  wilaya: string;
  company: string;
  date_creation_user: string;
  role_name: string;
}

export function Users() {
  const currentPageRef = useRef(1);
  const { translate } = useTranslate();
  const [list_user, setListUser] = useState<User[]>([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const user_id =
    localStorage.getItem("userid") || localStorage.getItem("user_id");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selecteduser_id, setSelecteduser_id] = useState<string | null>(null);
  const [showDeletedUsersModal, setShowDeletedUsersModal] = useState(false);
  const [deletedUsers, setDeletedUsers] = useState<DeletedUser[]>([]);
  const [deletedUsersCount, setDeletedUsersCount] = useState<number>(0);
  const [sortType, setSortType] = useState("id_user");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [list, setList] = useState<User[]>([]);
  const navigate = useNavigate();
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showHardDeleteModal, setShowHardDeleteModal] = useState(false);
  const [hardDeleteUserId, setHardDeleteUserId] = useState<number | null>(null);
  const { login } = useAuth();
  const [search, setSearch] = useState("");
  const [type, setType] = useState(0);
  const [typeSearch, setTypeSearch] = useState("username");
  const [selectedSearch, setSelectedSearch] = useState("Username");

  const Options = ["id", "username", "email", "phone", "role"];

  const handleTypeSearch = (event: any) => {
    const selectedValue = event.target.textContent?.trim();
    currentPageRef.current = 1;

    switch (selectedValue) {
      case translate("id"):
        setType(0);
        setTypeSearch("id");
        break;
      case translate("username"):
        setType(1);
        setTypeSearch("username");
        break;
      case translate("email"):
        setType(2);
        setTypeSearch("email");
        break;
      case translate("phone"):
        setType(3);
        setTypeSearch("phone");
        break;
      case translate("role"):
        setType(4);
        setTypeSearch("role");
        break;
      default:
        setType(1);
        setTypeSearch("username");
        break;
    }
  };

  const handleAdvancedSearch = (event: any) => {
    const newValue = event.target.value;
    currentPageRef.current = 1;
    setSearch(newValue);
  };

  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    setLimit(newValue);
    const commentsFormServer = await fetchUser(
      currentPageRef.current,
      newValue,
    );
    setListUser(commentsFormServer);
  };

  const fetchUserData = async (
    currentPage: number,
    limit: number,
    sortType: string,
    sortDirection: string,
    search?: string,
    type?: number,
  ) => {
    try {
      setLoading(true);

      const totalRes = await fetch(
        `${backendUrl}/api/users/total?page=${currentPage}&limit=${limit}&search=${search}&type=${type}`,
        { mode: "cors" },
      );
      const totalData = await totalRes.json();
      const total = totalData[0].total;
      setTotal(total);

      const calculatedPageCount = Math.ceil(total / limit);
      setPageCount(calculatedPageCount);

      const res = await fetch(
        `${backendUrl}/api/users?page=${currentPage}&limit=${limit}&sortColumn=${sortType}&sortOrder=${sortDirection}&search=${search}&type=${type}`,
        { mode: "cors" },
      );

      if (!res.ok) {
        throw new Error(
          `Erreur lors de la récupération des utilisateurs. Statut : ${res.status}`,
        );
      }

      const data = await res.json();
      setListUser(data);
      setList(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData(
      currentPageRef.current,
      limit,
      sortType,
      sortDirection,
      search,
      type,
    );
  }, [user_id, limit, sortType, sortDirection, search, type]);

  const fetchUser = async (currentPage: number, limit: any) => {
    const res = await fetch(
      `${backendUrl}/api/users?page=${currentPage}&limit=${limit}&sortColumn=${sortType}&sortOrder=${sortDirection}&search=${search}&type=${type}`,
      { mode: "cors" },
    );
    const data = await res.json();
    return data;
  };

  const handlePageClick = async (data: { selected: number }) => {
    currentPageRef.current = data.selected + 1;

    const commentsFormServer = await fetchUser(currentPageRef.current, limit);
    setListUser(commentsFormServer);

    fetchUserData(
      currentPageRef.current,
      limit,
      sortType,
      sortDirection,
      search,
      type,
    );
  };

  const handleDeleteClick = async (user_id: string) => {
    setSelecteduser_id(user_id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const refreshUserData = async () => {
    await fetchUserData(
      currentPageRef.current,
      limit,
      sortType,
      sortDirection,
      search,
      type,
    );
  };

  const handleConfirmDelete = async () => {
    try {
      const loggedInuser_id = localStorage.getItem("userid");

      const response = await fetch(
        `${backendUrl}/api/softDeleteUser/${selecteduser_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ loggedInuser_id: loggedInuser_id }),
        },
      );

      if (!response.ok) {
        throw new Error(
          `Erreur lors de la suppression logique. Statut : ${response.status}`,
        );
      }

      await response.json();

      toast.success(translate("User Deleted successfully !"), {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      setShowModal(false);
      await refreshUserData();
      await fetchDeletedUsersCount();

      if (showDeletedUsersModal) {
        await fetchDeletedUsers();
      }
    } catch (error) {
      console.error(error);
    }

    try {
      const timestamp = new Date(Date.now() + 60 * 60 * 1000)
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      const details = `Delete user: ${selecteduser_id}`;

      await fetch(`${backendUrl}/api/log-user-action/${user_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "Delete",
          page: "Users",
          operation: "supprimer",
          timestamp,
          details,
        }),
      });
    } catch (error) {
      console.error("Error logging user action:", error);
    }
  };

  const fetchDeletedUsers = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/deleted-users/${user_id}`,
        { mode: "cors" },
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching deleted users. Status: ${response.status}`,
        );
      }

      const data = await response.json();
      setDeletedUsers(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleShowDeletedUsersModal = async () => {
    await fetchDeletedUsers();
    await fetchDeletedUsersCount();
    setShowDeletedUsersModal(true);
  };

  const handleCloseDeletedUsersModal = () => {
    setShowDeletedUsersModal(false);
  };

  const fetchDeletedUsersCount = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/deleted-users-count/${user_id}`,
        { mode: "cors" },
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching deleted users count. Status: ${response.status}`,
        );
      }

      const data = await response.json();
      setDeletedUsersCount(data.count);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDeletedUsersCount();
  }, [user_id]);

  const handleRestore = async (id_user: number) => {
    try {
      const response = await fetch(`${backendUrl}/api/restoreUser/${id_user}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error restoring the user. Status: ${response.status}`);
      }

      toast.success(translate("User Restored successfully !"), {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      await fetchDeletedUsers();
      await fetchDeletedUsersCount();
      await refreshUserData();
    } catch (error) {
      console.error(error);
    }
  };

  const handleHardDelete = (id_user: number) => {
    setHardDeleteUserId(id_user);
    setShowHardDeleteModal(true);
  };

  const handleConfirmHardDelete = async () => {
    if (!hardDeleteUserId) return;

    try {
      const response = await fetch(
        `${backendUrl}/api/hardDeleteUser/${hardDeleteUserId}`,
        { method: "DELETE" },
      );

      if (!response.ok) throw new Error(`Status: ${response.status}`);

      toast.success(translate("User permanently deleted!"), {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      });

      await fetchDeletedUsers();
      await fetchDeletedUsersCount();
    } catch (error) {
      console.error(error);
    } finally {
      setShowHardDeleteModal(false);
      setHardDeleteUserId(null);
    }
  };

  const handleSort = async (type: "id_user") => {
    let sortOrder: "asc" | "desc" = "asc";

    if (type === sortType) {
      sortOrder = sortDirection === "asc" ? "desc" : "asc";
    }

    setSortType(type);
    setSortDirection(sortOrder);
  };

  const handleSelection = (user_id: number) => {
    const isSelected = selectedUsers.includes(user_id);

    if (isSelected) {
      setSelectedUsers(selectedUsers.filter((id) => id !== user_id));
    } else {
      setSelectedUsers([...selectedUsers, user_id]);
    }
  };

  const handleSelectAllCheckboxChange = () => {
    if (selectAll) {
      setSelectedUsers([]);
    } else {
      const alluser_ids = list_user.map((item) => item.id_user);
      setSelectedUsers(alluser_ids);
    }

    setSelectAll(!selectAll);
  };

  const generateExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Users");

      const headers = [
        "ID",
        "Nom",
        "Nom d'utilisateur",
        "Email",
        "Téléphone",
        "Région",
        "Date d'inscription",
      ];
      worksheet.addRow(headers);

      list_user.forEach((user) => {
        if (selectedUsers.includes(user.id_user)) {
          worksheet.addRow([
            user.id_user,
            `${user.nom_user} ${user.prenom_user}`,
            user.username_user,
            user.email_user,
            user.phone_user,
            user.wilaya,
            new Date(user.date_creation_user).toLocaleDateString(),
          ]);
        }
      });

      worksheet.columns.forEach((column) => {
        column.width = Math.max(column.width ?? 0, 25);
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const currentDate = new Date();
      const dateString = currentDate.toISOString().split("T")[0];
      const timeString = currentDate
        .toTimeString()
        .split(" ")[0]
        .replace(/:/g, "-");
      const fileName = `Liste_users_${dateString}_${timeString}.xlsx`;

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Erreur lors de la génération du fichier Excel :", error);
    }

    setSelectedUsers([]);
    setSelectAll(false);
  };

  const handleUserSelection = async (
    id_role: number,
    id_user: number,
    username: string,
  ) => {
    try {
      const response = await axios.post(
        `${backendUrl}/api/switch-user`,
        { id_user },
        { withCredentials: true },
      );

      console.log("switch-user response:", response.data);

      localStorage.setItem("userid", id_user.toString());
      localStorage.setItem("user_id", id_user.toString());
      localStorage.setItem("username", username);

      await login();

      window.location.href = "/";
    } catch (error: any) {
      console.error("Erreur lors du changement d'utilisateur :", error);
      console.error("Response:", error?.response?.data);
      alert("Impossible de changer d'utilisateur.");
    }
  };

  const getRoleBadge = (role: string) => {
    const value = (role || "").toLowerCase();

    const config = {
      admin: {
        label: translate("Admin"),
        bg: "linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)",
        color: "#b91c1c",
        border: "#fda4af",
        dot: "#ef4444",
        shadow: "0 4px 14px rgba(239, 68, 68, 0.14)",
      },
      supplier: {
        label: translate("Supplier"),
        bg: "linear-gradient(135deg, #ecfdf3 0%, #d1fae5 100%)",
        color: "#166534",
        border: "#86efac",
        dot: "#22c55e",
        shadow: "0 4px 14px rgba(34, 197, 94, 0.16)",
      },
      oem: {
        label: translate("OEM"),
        bg: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
        color: "#b45309",
        border: "#fcd34d",
        dot: "#f59e0b",
        shadow: "0 4px 14px rgba(245, 158, 11, 0.14)",
      },
    };

    const current = config[value as keyof typeof config] || config.oem;

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          padding: "6px 14px",
          borderRadius: "999px",
          background: current.bg,
          color: current.color,
          border: `1px solid ${current.border}`,
          boxShadow: current.shadow,
          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: current.dot,
          }}
        />
        {current.label}
      </span>
    );
  };

  const actionButtonStyle = {
    width: "40px",
    height: "40px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    borderRadius: "50%",
    border: "none",
    boxShadow: "0 6px 16px rgba(15, 23, 42, 0.08)",
    transition: "all 0.2s ease",
  } as const;

  const getActionButtonStyle = (
    bg: string,
    color: string = "#ffffff",
    border?: string,
  ) => ({
    ...actionButtonStyle,
    backgroundColor: bg,
    color,
    border: border ? `1px solid ${border}` : "none",
  });

  return (
    <>
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>
              <i
                className="las la-user"
                data-rel="bootstrap-tooltip"
                title="Users"
              ></i>
              {translate("Users")} ( {total} )
            </h4>
          </div>

          <div className="col-md-6">
            <div className="text-right embed-responsive">
              <div
                id="DataTables_Table_0_filter"
                className="dataTables_filter"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <Link
                  to="/User"
                  className="btn"
                  style={{
                    backgroundColor: "#facc15",
                    border: "1px solid #facc15",
                    color: "#111827",
                    fontWeight: 400,
                    borderRadius: "8px",
                    padding: "8px 14px",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <i className="las la-plus mr-2"></i>
                  {translate("New Users")}
                </Link>

                <Button
                  className="btn"
                  style={{
                    backgroundColor: "#facc15",
                    border: "1px solid #facc15",
                    color: "#111827",
                    fontWeight: 400,
                    borderRadius: "8px",
                    padding: "8px 14px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onClick={generateExcel}
                >
                  <i className="las la-file-excel mr-2"></i>
                  {translate("Download Excel")}
                </Button>

                <Button
                  className="btn"
                  style={{
                    backgroundColor: "#ef4444",
                    border: "1px solid #ef4444",
                    color: "#ffffff",
                    fontWeight: 400,
                    borderRadius: "8px",
                    padding: "8px 14px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onClick={handleShowDeletedUsersModal}
                >
                  <i className="las la-trash-alt mr-2"></i>
                  {translate("Deleted Users")} ({deletedUsersCount})
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginTop: "15px" }}>
          <div className="col-md-6">
            <div className="input-group">
              <Dropdown>
                <Dropdown.Toggle variant="link">
                  <i className="fas fa-chevron-down"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu onClick={handleTypeSearch}>
                  {Options.map((option) => (
                    <Dropdown.Item key={option}>
                      {translate(option)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <input
                type="text"
                className="form-control"
                placeholder={`${translate("search_by")} ${translate(typeSearch)}`}
                value={search}
                onChange={handleAdvancedSearch}
              />

              <Button
                variant="secondary"
                style={{ height: "38px" }}
                onClick={() => {
                  currentPageRef.current = 1;
                  setSearch("");
                }}
              >
                ✕
              </Button>
            </div>
          </div>

          <div className="col-md-6">
            <div
              className="dataTables_length text-right embed-responsive"
              id="DataTables_Table_0_length"
            >
              <label>
                {translate("Show")}
                <select
                  name="DataTables_Table_0_length"
                  aria-controls="DataTables_Table_0"
                  className="custom-select custom-select-sm form-control form-control-sm mr-2 ml-2"
                  style={{ width: "66px" }}
                  onChange={handleSelectChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </select>
                {translate("entries")}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="table-responsive">
          <Table className="dataTable table">
            <thead className="bg-white text-uppercase">
              <tr className="ligth ligth-data">
                <th>
                  <div className="checkbox d-inline-block">
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      id="selectAllCheckbox"
                      onChange={handleSelectAllCheckboxChange}
                      checked={selectAll}
                    />
                    <label htmlFor="selectAllCheckbox" className="mb-0"></label>
                  </div>
                </th>
                <th style={{ width: "199px", cursor: "pointer" }}>
                  <span onClick={() => handleSort("id_user")}>
                    {translate("Id")}
                    {sortType === "id_user" && sortDirection === "asc" && " ▲"}
                    {sortType === "id_user" && sortDirection === "desc" && " ▼"}
                  </span>
                </th>
                <th>{translate("name")}</th>
                <th>{translate("User name")}</th>
                <th>{translate("Company")}</th>
                <th>{translate("Email")}</th>
                <th>{translate("Phone")}</th>
                <th>{translate("region")}</th>
                <th>{translate("Registration date")}</th>
                <th>{translate("Role")}</th>
                <th>{translate("Actions")}</th>
              </tr>
            </thead>

            {loading ? (
              <tr>
                <td colSpan={12}>
                  <div className="text-center">
                    <PropagateLoader
                      color={"#123abc"}
                      loading={loading}
                      size={20}
                    />
                  </div>
                </td>
              </tr>
            ) : (
              <>
                {Array.isArray(list_user) &&
                  list_user.length !== 0 &&
                  list_user.map((item) => {
                    return (
                      <tbody key={item["id_user"]} className="ligth-body">
                        <tr className={String(item["id_user"])}>
                          <td>
                            <div className="checkbox d-inline-block">
                              <input
                                type="checkbox"
                                className="checkbox-input"
                                id={`checkbox-${item["id_user"]}`}
                                onChange={() =>
                                  handleSelection(item["id_user"])
                                }
                                checked={selectedUsers.includes(
                                  item["id_user"],
                                )}
                              />
                              <label
                                htmlFor={`checkbox-${item["id_user"]}`}
                                className="mb-0"
                              ></label>
                            </div>
                          </td>

                          <td>{item["id_user"]}</td>
                          <td>
                            {item["nom_user"]} {item["prenom_user"]}
                          </td>
                          <td>{item["username_user"]}</td>
                          <td>{item["company"]}</td>
                          <td id="5">{item["email_user"]}</td>
                          <td>{item["phone_user"]}</td>
                          <td>{item["wilaya"]}</td>
                          <td>
                            {new Date(
                              item["date_creation_user"],
                            ).toLocaleDateString()}
                          </td>
                          <td>{getRoleBadge(item["role_name"])}</td>
                          <td>
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{ gap: "10px", flexWrap: "nowrap" }}
                            >
                              {user_id === "1" && (
                                <Fragment>
                                  <button
                                    type="button"
                                    className="btn btn-sm"
                                    style={getActionButtonStyle("#020817")}
                                    title={translate("Go")}
                                    onClick={() =>
                                      handleUserSelection(
                                        item["id_role"],
                                        item["id_user"],
                                        item["username_user"],
                                      )
                                    }
                                  >
                                    <i
                                      className="fas fa-user"
                                      style={{ fontSize: "13px" }}
                                    ></i>
                                  </button>

                                  <Link
                                    to={`/notification-center/${item["id_user"]}`}
                                    className="btn btn-sm"
                                    style={{
                                      ...getActionButtonStyle("#f59e0b"),
                                      textDecoration: "none",
                                    }}
                                    title={translate("Send notification")}
                                  >
                                    <i
                                      className="fas fa-bell"
                                      style={{ fontSize: "13px" }}
                                    ></i>
                                  </Link>
                                </Fragment>
                              )}

                              <Link
                                to={`/User/${item["id_user"]}`}
                                className="btn btn-sm"
                                style={{
                                  ...getActionButtonStyle(
                                    "#facc15",
                                    "#111827",
                                    "#facc15",
                                  ),
                                  textDecoration: "none",
                                }}
                                title={translate("Edit")}
                              >
                                <i
                                  className="fas fa-edit"
                                  style={{ fontSize: "13px" }}
                                ></i>
                              </Link>

                              <button
                                type="button"
                                className="btn btn-sm"
                                style={getActionButtonStyle("#ef4444")}
                                title={translate("Delete")}
                                onClick={() =>
                                  handleDeleteClick(String(item["id_user"]))
                                }
                              >
                                <i
                                  className="fas fa-trash"
                                  style={{ fontSize: "13px" }}
                                ></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
              </>
            )}
          </Table>
        </div>

      
      </div>

        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <span>
              {translate("Displaying")} {list_user.length} {translate("out of")}{" "}
              {total}
            </span>
          </div>

          <div className="col-md-6 d-flex justify-content-end">
            <ReactPaginate
              previousLabel={translate("previous")}
              nextLabel={translate("next")}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </div>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              fontSize: "18px",
              fontWeight: 500,
              color: "#1f2937",
            }}
          >
            {translate("Confirmation of deletion.")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="text-center"
          style={{
            fontSize: "16px",
            color: "#374151",
            padding: "28px 20px",
          }}
        >
          {translate("Do you really want to delete this user?")}
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "1px solid #e5e7eb",
            padding: "16px 20px",
            gap: "10px",
          }}
        >
          <Button
            onClick={handleCloseModal}
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #cbd5e1",
              color: "#334155",
              borderRadius: "10px",
              padding: "8px 18px",
              fontWeight: 500,
              minWidth: "110px",
              boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)",
            }}
          >
            {translate("Cancel")}
          </Button>

          <Button
            onClick={handleConfirmDelete}
            style={{
              backgroundColor: "#ef4444",
              border: "1px solid #ef4444",
              color: "#ffffff",
              borderRadius: "10px",
              padding: "8px 18px",
              fontWeight: 500,
              minWidth: "110px",
              boxShadow: "0 6px 16px rgba(239, 68, 68, 0.18)",
            }}
          >
            {translate("Delete")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeletedUsersModal}
        onHide={handleCloseDeletedUsersModal}
        dialogClassName="modal-lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            {translate("Deleted Users")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {deletedUsers.length === 0 ? (
            <div className="text-center py-4 text-muted">
              {translate("No deleted users found")}
            </div>
          ) : (
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>{translate("ID")}</th>
                  <th>{translate("Username")}</th>
                  <th className="text-right">{translate("Actions")}</th>
                </tr>
              </thead>
              <tbody>
                {deletedUsers.map((user) => (
                  <tr key={user.id_user}>
                    <td>{user.id_user}</td>
                    <td>{user.name}</td>
                    <td
                      className="text-right"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "#22c55e",
                          border: "1px solid #22c55e",
                          color: "#ffffff",
                          borderRadius: "8px",
                          padding: "6px 12px",
                          fontWeight: 400,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                        onClick={() => handleRestore(user.id_user)}
                      >
                        <i className="las la-undo"></i>
                        {translate("Restore")}
                      </Button>

                      <Button
                        style={{
                          backgroundColor: "#ef4444",
                          border: "1px solid #ef4444",
                          color: "#ffffff",
                          borderRadius: "8px",
                          padding: "6px 12px",
                          fontWeight: 400,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                        onClick={() => handleHardDelete(user.id_user)}
                      >
                        <i className="las la-trash"></i>
                        {translate("Delete Permanently")}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "#64748b",
              border: "1px solid #64748b",
              color: "#ffffff",
              borderRadius: "8px",
              padding: "6px 14px",
              fontWeight: 400,
            }}
            onClick={handleCloseDeletedUsersModal}
          >
            {translate("Close")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showHardDeleteModal}
        onHide={() => setShowHardDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{translate("Permanent Deletion")}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {translate(
            "Are you sure you want to permanently delete this user? This action cannot be undone.",
          )}
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "1px solid #e5e7eb",
            padding: "16px 20px",
            gap: "10px",
          }}
        >
          <Button
            onClick={() => setShowHardDeleteModal(false)}
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #cbd5e1",
              color: "#334155",
              borderRadius: "10px",
              padding: "8px 18px",
              fontWeight: 500,
              minWidth: "120px",
              boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)",
            }}
          >
            {translate("Cancel")}
          </Button>

          <Button
            onClick={handleConfirmHardDelete}
            style={{
              backgroundColor: "#dc2626",
              border: "1px solid #dc2626",
              color: "#ffffff",
              borderRadius: "10px",
              padding: "8px 18px",
              fontWeight: 500,
              minWidth: "170px",
              boxShadow: "0 6px 16px rgba(220, 38, 38, 0.2)",
            }}
          >
            <i className="las la-trash mr-1"></i>
            {translate("Delete Permanently")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
